module.exports = __webpack_public_path__ + "img/lg_ring_g_o_0_1@2x.5178710f.png";